import { lazy, type FC } from 'react';
import { useParams } from 'react-router';
import { usePublicStorageOffers } from 'src/apis/storage/use-public-storage-offers';
import { useStorageOfferDetails } from 'src/apis/storage/use-storage-offer-details';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { storageOffersListDefaultParams } from 'src/pages/storage/offers-new/utils';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageOfferReservePriceEdit: FC<Props> = ({
  storageServiceRoot,
}) => {
  const { offerId } = useParams<{ offerId: string }>();

  const storageOffers = usePublicStorageOffers({
    storageServiceRoot,
    params: storageOffersListDefaultParams,
  });

  const storageOfferDetails = useStorageOfferDetails({
    storageOffers,
    offerId,
  });

  if (!storageOffers.response || !storageOfferDetails?.response) {
    return <PageSpinner />;
  }

  if (
    !storageOfferDetails.response.data._links.recalculateOfferAllocationProposal
  ) {
    throw new Forbidden();
  }

  return <Page storageOfferDetails={storageOfferDetails} />;
};
